import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var MenuOption = function MenuOption(_ref) {
  var items = _ref.items;
  var getClassName = getClassNameFactory(MenuOption.displayName);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "tooltip",
    className: getClassName()
  }, items.map(function (item, index) {
    var onClick = item.onClick,
        icon = item.icon,
        value = item.value;
    return /*#__PURE__*/React.createElement("button", {
      onClick: onClick,
      key: (item === null || item === void 0 ? void 0 : item.key) || index,
      className: getClassName({
        descendantName: "items"
      })
    }, icon && /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "icon"
      })
    }, icon), value && /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "value"
      })
    }, value));
  }));
};

MenuOption.displayName = "MenuOption";
export default MenuOption;